import { TFunction } from 'react-i18next';
import { RelativeDayName, getRelativeDayString } from '../../../../core/util/date';

export const getAvailableSlots = (slots: any) =>
  slots.filter((slot: any) => slot.availability > 0 && !slot.isReservationsDisabled);

export const getSlotSelectionProperties = (slots: any) => {
  const visibleSlots = slots;
  const availableSlots = getAvailableSlots(slots);
  const busySlots = availableSlots.filter((slot: any) => slot.isBusy);
  return {
    visibleSlots: visibleSlots.length,
    availableSlots: availableSlots.length,
    busySlots: busySlots.length,
  };
};

export const getBookAheadVisitsFullyBookedXDayCopy = (
  day: RelativeDayName,
  t: TFunction<'common'>
) => {
  if (day === RelativeDayName.TODAY) {
    return t('bookingTimeSelector.slotSelectorStates.noSlotsLeft.bookAheadVisitsFullyBookedToday');
  }
  if (day === RelativeDayName.TOMORROW) {
    return t(
      'bookingTimeSelector.slotSelectorStates.noSlotsLeft.bookAheadVisitsFullyBookedTomorrow'
    );
  }
  return t('bookingTimeSelector.slotSelectorStates.noSlotsLeft.bookAheadVisitsFullyBookedXDay', {
    day: getRelativeDayString(day, t, false),
  });
};

export const getNoAvailabilityXDay = (day: RelativeDayName, t: TFunction<'common'>) => {
  if (day === RelativeDayName.TODAY) {
    return t('bookingTimeSelector.slotSelectorStates.noSlotsLeft.noAvailabilityToday');
  }
  if (day === RelativeDayName.TOMORROW) {
    return t('bookingTimeSelector.slotSelectorStates.noSlotsLeft.noAvailabilityTomorrow');
  }
  return t('bookingTimeSelector.slotSelectorStates.noSlotsLeft.noAvailabilityXDay', {
    day: getRelativeDayString(day, t, false),
  });
};

export const getClinicClosedXDay = (day: RelativeDayName, t: TFunction<'common'>) => {
  if (day === RelativeDayName.TODAY) {
    return t('bookingTimeSelector.slotSelectorStates.clinicClosed.thisClinicIsClosedToday');
  }
  if (day === RelativeDayName.TOMORROW) {
    return t('bookingTimeSelector.slotSelectorStates.clinicClosed.thisClinicIsClosedTomorrow');
  }
  if (day === RelativeDayName.YESTERDAY) {
    return t('bookingTimeSelector.slotSelectorStates.clinicClosed.thisClinicWasClosedYesterday');
  }
  return t('bookingTimeSelector.slotSelectorStates.clinicClosed.thisClinicIsClosedXDay', {
    day: getRelativeDayString(day, t, false),
  });
};

export const getYouCanStillBookXDay = (day: RelativeDayName, t: TFunction<'common'>) => {
  if (day === RelativeDayName.TODAY) {
    return t('bookingTimeSelector.slotSelectorStates.clinicClosed.youCanStillBookToday');
  }
  if (day === RelativeDayName.TOMORROW) {
    return t('bookingTimeSelector.slotSelectorStates.clinicClosed.youCanStillBookTomorrow');
  }
  return t('bookingTimeSelector.slotSelectorStates.clinicClosed.youCanStillBookXDay', {
    day: getRelativeDayString(day, t, false),
  });
};
